/**
 * knownRoutes.js — App.js'te tanımlı bilinen üst-seviye route segmentleri.
 *
 * BULGU (coordinator, uçtan uca gönderim testi): admin toplu bildirim
 * deeplink alanının Türkçe placeholder'ı ("/kurslar") gerçekte var olmayan
 * bir route öneriyordu — admin bu örneği aynen kullanıp gönderdi, öğrenci
 * bildirime tıklayınca landing'e düştü. `isSafeInternalDeeplink` (bkz.
 * deeplink.js) sadece "bu path açık yönlendirme riski taşıyor mu" kontrolü
 * yapar, "bu route gerçekten var mı" kontrolü YAPMAZ — placeholder'ı gerçek
 * bir route'a (/courses) çevirmek yeterli değil, gelecekte admin farklı
 * (yanlış) bir path girerse de sessizce ölü link üretilmemeli.
 *
 * Bu modül SADECE bir heuristik uyarı için kullanılır — backend
 * validasyonunun (is_safe_internal_deeplink, open-redirect guard) YERİNE
 * GEÇMEZ ve gönderimi ENGELLEMEZ (admin bilinçli olarak yeni eklenmiş, henüz
 * listeye girmemiş bir route'a da link verebilmeli).
 *
 * SENKRONİZASYON: liste elle bakımlı. knownRoutes.test.js, App.js kaynağını
 * okuyup her segmentin gerçekten orada bir `path="..."` olarak geçtiğini
 * doğrulayarak listenin App.js'ten TAMAMEN kopmasını (drift) engeller —
 * ama App.js'e YENİ bir route eklenip buraya eklenmemesini YAKALAMAZ (o
 * yönde otomatik senkronizasyon orantısız karmaşıklık — route tanımları
 * JSX içinde, güvenilir statik çıkarım için App.js'i parse eden bir build
 * script gerekir; bkz. proje raporu).
 */
export const KNOWN_ROUTE_PREFIXES = [
  '/admin',
  '/announcements',
  '/bildirimler',
  '/cabin-crew',
  '/certificates',
  '/checkout',
  '/courses',
  '/dashboard',
  '/documents',
  '/exam',
  '/favorites',
  '/instructor',
  '/legal',
  '/lesson',
  '/my-cabin-crew-group',
  '/my-courses',
  '/profile',
  '/programs',
  '/progress',
];

/**
 * Verilen path'in (query/hash hariç) bilinen bir route segmentiyle
 * eşleşip eşleşmediğini kontrol eder. Kök "/" ve boş/geçersiz değerler
 * her zaman "bilinir" sayılır (bu fonksiyon sadece belirgin yanlış
 * segmentleri yakalamak için — format doğrulaması deeplink.js'nin işi).
 *
 * @param {string} path
 * @returns {boolean}
 */
export function isKnownRoutePath(path) {
  if (!path) return true;
  const clean = path.split('?')[0].split('#')[0];
  if (clean === '/' || clean === '') return true;
  return KNOWN_ROUTE_PREFIXES.some((prefix) => clean === prefix || clean.startsWith(`${prefix}/`));
}
